type LoadingStateProps = {
  label?: string;
};

/** Skeleton rows, not a spinner; the label stays for screen readers. */
export function LoadingState({ label = 'Cargando…' }: LoadingStateProps) {
  return (
    <div role="status" aria-label={label} className="skeleton">
      <div className="bone" />
      <div className="bone" />
      <div className="bone" />
    </div>
  );
}
